import { useDetailApi } from "../../../swr/useApi";
import { purchaseOrdersService } from "../../api_client";
import type { PurchaseOrderDetailsDto } from "../../../api";

export function usePurchaseOrderDetails(id: number) {
    return useDetailApi<PurchaseOrderDetailsDto>({
        key: `purchase-order-details-${id}`,
        serviceMethod: async () => await purchaseOrdersService.getPurchaseOrderDetails(id),
        options: { refreshInterval: 10_000 },
    });
}

